import script from "./recommendItem.vue?vue&type=script&setup=true&lang=js"
export * from "./recommendItem.vue?vue&type=script&setup=true&lang=js"

import "./recommendItem.vue?vue&type=style&index=0&id=fc7f377e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc7f377e"]])

export default __exports__